export const firebaseContext = ['firebase'];

export const userContext = ['user'];

export const showNavContext = ['showNav'];
